import React from "react";
import {
    Box,
    TextField,
    FormControl,
    InputAdornment,
    InputLabel,
    Input,
    IconButton,
    Button,
    Typography,
    Select,
    MenuItem,
    FormHelperText,
    Alert,
    Tabs,
    Tab
} from "@mui/material";
import {
    AccountCircleOutlined,
    Visibility,
    VisibilityOff,
    LockOutlined,
    Group,
} from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { set, range } from "lodash";
import { Grid } from "../../components/table";
import { CONFIG } from "../../../config";
import axios from "axios";
import { ToolBar } from "../../components/toolbar";
import { Modal } from "../../components/modal";
import { FormA } from "../../components/form";
import moment from "moment";
import { getFormState } from "../../../helpers/form";
import dayjs from "dayjs";
import { LiveAllocation } from '../allocation/live-allocation';

import IosShareIcon from "@mui/icons-material/IosShare";
import PropTypes from 'prop-types';
const durationPulgin = require('dayjs/plugin/duration')
dayjs.extend(durationPulgin)


const API_HOST = CONFIG.modules["accounts"].host;
const API_HOST_CRM = CONFIG.modules["crm"].host;

export const DateWiseTrend = ({ heading, type }) => {
    const {
        roles,
        user,
        users,
        Designations,
        Departments,
        Languages,
        Districts,
        map
    } = useSelector((state) => state.user || {});
    const userStore = useSelector((state) => state.user || {});
    console.log('length', dayjs.duration().asWeeks())
    const [filter, setFilter] = useState({
        callDate: dayjs()
    });
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(25);
    const [count, setCount] = useState(0);
    const [data, setData] = useState([]);

    const getCasesByDate = () => {

        axios.get(API_HOST_CRM + `/cases-by-date?callDate=${dayjs(filter.callDate).format('YYYY-MM-DD')}`).then((resp) => {
            if (resp.data && resp.data.success) {
                setData(Object.keys(resp.data.data).map((d)=> {
                    return {userId: d, cases: resp.data.data[d]}
                }))
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    useEffect(()=>{
        getCasesByDate()
    },[])

    useEffect(()=> {
        getCasesByDate()
    }, [filter])



    return (
        <>



            <ToolBar
                name={heading}
                height={'4em'}

                // onClearFilter={() => {
                //     setFilter({
                //         callDate: null
                //     })
                // }}
                filters={[
                    {
                        field: {
                            name: "callDate",
                            type: "date",
                            label: "By Date",
                        },
                        onChange: (name, value) => {
                            filter[name] = value;
                            setFilter({ ...filter });
                        },
                        state: filter,
                    },


                ]}
            />
            <Box sx={{ mt: 2 }}>
                <Grid
                    data={data||[]}
                    columns={[
                        { id: "userId", label: "Agent", minWidth: 70, format: (data, row) => {
                            return (map.users || {})[data]?.name ||''
                        } },
                        { id: "userId", label: "Alloted", minWidth: 70, format: (data, row) => {
                            return row?.cases?.length ||0
                        } },
                        { id: "userId", label: "Connected", minWidth: 70, format: (data, row) => {
                            return row?.cases?.filter(c=>c.attempt >0&& ['Completed', 'Call done',
                            'Not in the portal',
                            'Miscarriage', 'Call Incomplete', 'Deceased Child',
                            'Language Barrier', 'Deceased Mother', 'Deceased (Mother and Child)', 'Duplicate Mother Id'
                        ].includes(c.status)).length ||0
                        } },
                        { id: "userId", label: "Attempted", minWidth: 70, format: (data, row) => {
                            return row?.cases?.filter(c=>c.attempt >0).length ||0
                        } },
                        { id: "userId", label: "Pending", minWidth: 70, format: (data, row) => {
                            return row?.cases?.filter(c=>c.status == 'Pending').length ||0
                        } },
                    ]}


                ></Grid>
            </Box>

        </>
    );
};